import { Button, UIHeading1, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import { NO_BREAK_SPACE } from '../../constants/symbolsUnicode';
import * as style from './NewbuildingPrizeBanner.css';

export interface INewbuildingPrizeBannerProps {
  onClick: () => void;
  url: string;
}

export const NewbuildingPrizeBanner = ({ onClick, url }: INewbuildingPrizeBannerProps) => {
  return (
    <a
      className={style['container']}
      data-testid="NewbuildingPrizeBanner"
      href={url}
      rel="noopener noreferrer"
      target="_blank"
      onClick={onClick}
    >
      <div className={style['content']}>
        <div className={style['text-group']}>
          <UIHeading1 color="text-inverted-default">
            350{NO_BREAK_SPACE}000{NO_BREAK_SPACE}₽ за{NO_BREAK_SPACE}покупку новостройки
          </UIHeading1>
          <UIText1 color="text-inverted-default">Разыграем приятный бонус на{NO_BREAK_SPACE}новоселье</UIText1>
        </div>

        <Button size="M" theme="fill_white_primary" type="button">
          Как получить приз
        </Button>
      </div>

      <div aria-hidden={true} className={style['image-slot']} />
    </a>
  );
};
